import StepIndicator from './stepIndicator';
import './stepIndicator.scss';

function StepIndicators({ steps, currentStep, experience }) {
  return (
    <ul className="list-unstyled step-indicators">
      {steps.map((step, i) => {
        return (
          <StepIndicator
            key={step.label}
            label={step.label}
            isActive={currentStep === 1 ? currentStep === i+1 : currentStep > i+1}
            isPartial={currentStep === 2 && !experience ? false : currentStep > i+1}
            isCompleted={currentStep > i+2}
          />
        );
      })}
    </ul>
  );
}

export default StepIndicators;
